import _ from "lodash";
import { gql } from "lib/apolloClient";
import client from "lib/apolloClient/client";

import {
  getDefaultAccountManagerDetailsQuery,
  getFamilySelectedChildYearGroupQuery,
  getPlatformUserSessionDetailsQuery,
} from "./PlatformQuery";
import { getOrganizationDetailsQuery } from "../../../../modules/CommonQuery";

const PLATFORM_USER_TYPENAME_BY_ENTITY_TYPE = {
  STAFF: "Staff",
  STUDENT: "Student",
  FAMILY_MEMBER: "FamilyMember",
};

const platformUserCurriculumProgramsFragment = gql`
  fragment platformUserCurriculumPrograms on Node {
    ... on Staff {
      type
      organization {
        id
        curriculumPrograms {
          id
        }
      }
    }
    ... on Student {
      type
      organization {
        id
        curriculumPrograms {
          id
        }
      }
    }
    ... on FamilyMember {
      type
      children {
        id
        organization {
          id
          curriculumPrograms {
            id
          }
        }
      }
    }
  }
`;

export const getPlatformUserCurriculumProgramsFromCache = ({ id, type }) => {
  const __typename = PLATFORM_USER_TYPENAME_BY_ENTITY_TYPE[type];
  if (!__typename) return {};

  const cacheId = client.cache.identify({ __typename, id });
  if (!cacheId) return {};

  return (
    client.readFragment({
      id: cacheId,
      fragment: platformUserCurriculumProgramsFragment,
      fragmentName: "platformUserCurriculumPrograms",
    }) || {}
  );
};

export const getPlatformUserSessionDetailsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPlatformUserSessionDetailsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, `node`, {});
  else return {};
};

export const getDefaultAccountManagerDetailsFromCache = () => {
  let accountManagerDetails = {};
  try {
    accountManagerDetails = client.readQuery({
      query: getDefaultAccountManagerDetailsQuery,
    });
  } catch (e) {
    return {};
  }

  if (accountManagerDetails != null)
    return _.get(
      accountManagerDetails,
      `globalConstants.defaultAccountMangerDetails`,
      {}
    );
  else return {};
};

export const getOrganizationDetailsFromCache = organizationId => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationDetailsQuery,
      variables: {
        id: organizationId,
      },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getFamilySelectedChildYearGroupQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getFamilySelectedChildYearGroupQuery,
      variables,
    });
    return queryData || {};
  } catch (e) {
    return {};
  }
};
